// extracted by mini-css-extract-plugin
export default {"root":"TherapistAddEducation_root__v4XEB","lastRow":"TherapistAddEducation_lastRow__wldPW"};